export const FETCH_GOLF_HISTORICAL_SHOTS = 'FETCH_GOLF_HISTORICAL_SHOTS';
export const FETCH_GOLF_HISTORICAL_SHOTS_FETCHING = 'FETCH_GOLF_HISTORICAL_SHOTS_FETCHING';
export const FETCH_GOLF_HISTORICAL_SHOTS_SUCCESS = 'FETCH_GOLF_HISTORICAL_SHOTS_SUCCESS';
export const FETCH_GOLF_HISTORICAL_SHOTS_FAIL = 'FETCH_GOLF_HISTORICAL_SHOTS_FAIL';

export const FETCH_GOLF_PLAYER_SHOTS = 'FETCH_GOLF_PLAYER_SHOTS';
export const FETCH_GOLF_PLAYER_SHOTS_FETCHING = 'FETCH_GOLF_PLAYER_SHOTS_FETCHING';
export const FETCH_GOLF_PLAYER_SHOTS_SUCCESS = 'FETCH_GOLF_PLAYER_SHOTS_SUCCESS';
export const FETCH_GOLF_PLAYER_SHOTS_FAIL = 'FETCH_GOLF_PLAYER_SHOTS_FAIL';

export const UPDATE_GOLF_PLAYER_SHOTS = 'UPDATE_GOLF_PLAYER_SHOTS';
export const UPDATE_GOLF_PLAYER_SHOTS_UPDATING = 'UPDATE_GOLF_PLAYER_SHOTS_UPDATING';
export const UPDATE_GOLF_PLAYER_SHOTS_SUCCESS = 'UPDATE_GOLF_PLAYER_SHOTS_SUCCESS';
export const UPDATE_GOLF_PLAYER_SHOTS_FAIL = 'UPDATE_GOLF_PLAYER_SHOTS_FAIL';
